import Vue from 'vue'
import numFormat from "vue-filter-number-format";
import numeral from "numeral";
import * as LrnTypes from '../user/constants/lrn-types'
import * as ComplianceBundleStatuses from './constants/compliance-bundle-statuses'
import * as PortingStatuses from './constants/porting-statuses'

// general
Vue.filter("capitalize", (text) => {
    if (text) {
        return text.capitalize()
    } else {
        return ''
    }
})
Vue.filter("capitalize_all", (text) => {
    if (text) {
        return text.replace(/\b\w/g, l => l.toUpperCase())
    } else {
        return ''
    }
})
Vue.filter("initials", (name) => {
    let initials = name.match(/\b\w/g) || []
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()

    return initials
})
Vue.filter("humanReadableBool", (boolValue) => {
    if (boolValue) {
        return 'On'
    } else {
        return 'Off'
    }
})
Vue.filter("humanReadableDialMode", (mode) => {
    switch (mode) {
        case 0:
            return 'Simultaneous'
        case 1:
            return 'Sequential'
        case 2:
            return 'Round-robin'
    }
    return '-'
})
Vue.filter("ucfirst", (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
})
Vue.filter("checkIfEmpty", (value) => {
    if (!value) {
        return '-'
    } else {
        return value
    }
})
Vue.filter("checkIfTrue", (value) => {
    if (!value) {
        return '<i class="material-icons">&#xE876;</i>'
    } else {
        return '<i class="material-icons">&#xE14C;</i>'
    }
})
Vue.filter("prettifyCamelCase", (value) => {
    let output = "";
    let len = value.length;
    let char;

    for (let i=0 ; i<len ; i++) {
        char = value.charAt(i);

        if (i==0) {
            output += char.toUpperCase();
        }
        else if (char !== char.toLowerCase() && char === char.toUpperCase()) {
            output += " " + char;
        }
        else if (char == "-" || char == "_") {
            output += " ";
        }
        else {
            output += char;
        }
    }

    return output;
})
Vue.filter("ucwords", (value) => {
    return (value + '')
        .replace(/^(.)|\s+(.)/g, function ($1) {
            return $1.toUpperCase()
        })
})
Vue.filter("nl2br", (value) => {
    if (!value) {
        return '-'
    } else {
        let breakTag = '<br />';
        return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
})
Vue.filter("fixRounding", (amount, precision = 3) => {
    if (amount !== undefined) {
        return parseFloat(amount).toFixed(precision)
    } else {
        return '-'
    }
})
Vue.filter("roundOff", (amount) => {
    if (amount !== undefined) {
        return parseFloat(amount).toFixed(0)
    } else {
        return '-'
    }
});
Vue.filter('toCurrency', (amount) => {
    if (amount !== undefined) {
        if (amount < 0) {
            return '-$' + Math.abs(amount)
        }
        return '$' + amount
    } else {
        return '-'
    }
})
Vue.filter('lastItems', (elements, number = 1) => {
    if (elements && elements.length) {
        if (elements.length > number) {
            return elements.slice(Math.max(elements.length - number, 1))
        }

        return elements
    } else {
        return null
    }
})
// date / time / duration related
Vue.filter('fixDateTime', (dt) => {
    if (dt) {
        if (window.timezone) {
            return moment.utc(dt).tz(window.timezone).format('MM/DD/YYYY h:mma z')
        } else {
            return moment.utc(dt).local().format('MM/DD/YYYY h:mma z')
        }
    } else {
        return '-'
    }
})
Vue.filter('fixTime', (dt, format = 'h:mma') => {
    if (dt) {
        if (window.timezone) {
            return moment.utc(dt, 'HH:mm:ss').tz(window.timezone).format(format)
        } else {
            return moment.utc(dt, 'HH:mm:ss').local().format(format)
        }
    } else {
        return '-'
    }
})
Vue.filter('fixTimeLocal', (dt, format = 'h:mma') => {
    if (dt) {
        if (window.timezone) {
            return moment(dt, 'HH:mm:ss').format(format)
        } else {
            return moment(dt, 'HH:mm:ss').format(format)
        }
    } else {
        return '-'
    }
})
Vue.filter('fixDuration', (duration) => {
    if (duration) {
        return moment.duration(duration, 'seconds').format('m:ss', {
            trim: false
        })
    } else {
        return '-'
    }
})
Vue.filter('fixLongDuration', (duration) => {
    if (duration) {
        return moment.duration(duration, 'seconds').format('h:m:ss', {
            trim: false
        })
    } else {
        return '-'
    }
})
Vue.filter('fixFullDateUTC', (dt) => {
    if (dt) {
        if (window.timezone) {
            return moment.utc(dt).tz(window.timezone).format('MMM D, YYYY')
        } else {
            return moment.utc(dt).local().format('MMM D, YYYY')
        }
    } else {
        return '-'
    }
})
Vue.filter('fixFullDateLocal', (dt) => {
    if (dt) {
        if (window.timezone) {
            return moment(dt).utc().tz(window.timezone).format('MMM D, YYYY')
        } else {
            return moment(dt).utc().local().format('MMM D, YYYY')
        }
    } else {
        return '-'
    }
})
Vue.filter("fixFullDateUTCRelative", (dt) => {
    if (dt) {
        let now = moment.utc()
        let datetime = moment.utc(dt)

        if (now.diff(datetime) < 24 * 60 * 60 * 1000) {
            if (window.timezone) {
                return datetime.tz(window.timezone).fromNow()
            } else {
                return datetime.local().format('MMM D, YYYY')
            }
        } else {
            return datetime.format('MMM D, YYYY H:mma')
        }
    } else {
        return ''
    }
})
Vue.filter('fixName', (name) => {
    if (name) {
        return name.capitalize()
    }

    return ''
})
Vue.filter('fixLrnType', (lrn_type) => {
    lrn_type = parseInt(lrn_type)
    // LRN_TYPE_LANDLINE = 0 so it couldn't pass the if statement because 0 != true.
    if (lrn_type !== null) {
        switch (lrn_type) {
            case LrnTypes.LRN_TYPE_LANDLINE:
                return 'Landline'
            case LrnTypes.LRN_TYPE_WIRELESS:
                return 'Wireless'
            case LrnTypes.LRN_TYPE_VOIP:
                return 'Voip'
            case LrnTypes.LRN_TYPE_OTHER:
                return 'Other'
            case LrnTypes.LRN_NOT_PERFORMED:
                return 'LRN not performed'
            default:
                return 'Unknown'
        }
    }

    return 'Unknown'
})
// phone related
Vue.filter('fixPhone', (phoneNumber, format = 'E164', force = false) => {
    if (phoneNumber) {
        phoneNumber = phoneNumber.toString()
        phoneNumber = phoneNumber.replace(/\s+/g, '')
        phoneNumber = phoneNumber.replace('#', '')
        phoneNumber = phoneNumber.replace('.', '')

        if (phoneNumber.toLowerCase() === 'restricted') {
            return phoneNumber
        }

        if (phoneNumber.toLowerCase() === 'anonymous') {
            return phoneNumber
        }

        if (phoneNumber.toLowerCase() === 'unknown') {
            return phoneNumber
        }

        if (phoneNumber === '+266696687') {
            return phoneNumber
        }

        if (phoneNumber === '8656696') {
            return phoneNumber
        }

        if (phoneNumber.includes('unhold:')) {
            return phoneNumber
        }

        // sip uri used instead of phone number
        if (phoneNumber.indexOf('@') > -1) {
            return phoneNumber
        }

        // Use substring() and indexOf() functions to remove
        // portion of string after certain character (w => wait)
        let pos = phoneNumber.indexOf('w')
        if (pos !== -1) {
            phoneNumber = phoneNumber.substring(0, pos).trim()
        }

        let locale = window.guessLocale(phoneNumber)

        if (!locale) {
            return false
        }

        let tel = window.phoneUtil.parse(phoneNumber, locale)

        if (['US', 'CA'].includes(locale) && !force) {
            format = 'NATIONAL'
        }

        if (format == 'INTERNATIONAL') {
            return phoneUtil.format(tel, PNF.INTERNATIONAL).toString()
        } else if (format == 'E164') {
            return phoneUtil.format(tel, PNF.E164).toString()
        } else {
            return phoneUtil.format(tel, PNF.NATIONAL).toString()
        }
    } else {
        return ''
    }
})

/*
Parses date and render format function from moment.js
 */
Vue.filter('momentFormat', (datetime, format) => {
    return moment(datetime).format(format)
})

Vue.filter('numFormat', numFormat(numeral))

Vue.filter('statusColor', (value) => {
    switch (value) {
        case ComplianceBundleStatuses.STATUS_STAGED: // light grey
            return 'grey-300'
        case ComplianceBundleStatuses.STATUS_DRAFT: // dark grey
            return 'grey-500'
        case ComplianceBundleStatuses.STATUS_PENDING: // yellow
            return 'yellow-600'
        case ComplianceBundleStatuses.STATUS_IN_REVIEW: // blue
        case ComplianceBundleStatuses.CNAM_STATUS_IN_REVIEW:
            return 'blue-600'
        case ComplianceBundleStatuses.STATUS_REJECTED: // red
        case ComplianceBundleStatuses.STATUS_SUSPENDED:
        case ComplianceBundleStatuses.STATUS_EXPIRED:
        case ComplianceBundleStatuses.CNAM_STATUS_REJECTED:
            return 'red-600'
        case ComplianceBundleStatuses.STATUS_APPROVED: // green
        case ComplianceBundleStatuses.STATUS_PROVISIONALLY_APPROVED:
        case ComplianceBundleStatuses.CNAM_STATUS_APPROVED:
        case ComplianceBundleStatuses.STATUS_ONLINE:
            return 'green-600'
        case ComplianceBundleStatuses.STATUS_DELETED: // black
        default:
            return 'black-300'
    }
})

Vue.filter('statusName', (value) => {
    switch (value) {
        case 'UNVERIFIED':
            return 'Unverified'
        case ComplianceBundleStatuses.STATUS_STAGED:
            return 'Staged'
        case ComplianceBundleStatuses.STATUS_DRAFT:
            return 'Draft'
        case ComplianceBundleStatuses.STATUS_PENDING:
            return 'Pending Review'
        case ComplianceBundleStatuses.STATUS_IN_REVIEW:
        case ComplianceBundleStatuses.CNAM_STATUS_IN_REVIEW:
            return 'In Review'
        case ComplianceBundleStatuses.STATUS_REJECTED:
        case ComplianceBundleStatuses.CNAM_STATUS_REJECTED:
            return 'Rejected'
        case ComplianceBundleStatuses.STATUS_APPROVED:
        case ComplianceBundleStatuses.CNAM_STATUS_APPROVED:
            return 'Approved'
        case ComplianceBundleStatuses.STATUS_PROVISIONALLY_APPROVED:
            return 'Provisionally Approved'
        case ComplianceBundleStatuses.STATUS_EXPIRED:
            return 'Expired'
        case ComplianceBundleStatuses.STATUS_DELETED:
            return 'Deleted'
        case ComplianceBundleStatuses.STATUS_SUSPENDED:
            return 'Suspended'
        default:
            return '-'
    }
})

Vue.filter('portingStatusName', (value) => {
    switch (value) {
        case PortingStatuses.STATUS_NONE: // gray
            return 'None'
        case PortingStatuses.STATUS_PORTED_OUT: // blue
            return 'Ported Out'
        default:
            return '-'
    }
})
